import styled from 'styled-components'
import { theme } from 'src/Styles/theme'
import '@fontsource/open-sans'

export const LargeTitle = styled.div`
  user-select: none;
  @media (max-width: 768px) {
    ${theme.textStyles.rm32};
  }
  @media (min-width: 769px) {
    ${theme.textStyles.rm48};
    font-family: 'Open Sans'
  }
  color: ${theme.colors.defaultTextColor};
`

export const Title = styled.div`
  user-select: none;
  @media (max-width: 768px) {
    ${theme.textStyles.rb24};
  }
  @media (min-width: 769px) {
    ${theme.textStyles.rb34};
    font-family: 'Open Sans'
  }
  color: ${theme.colors.defaultTextColor};
`

export const Title1 = styled.div`
  user-select: none;
  @media (max-width: 768px) {
    ${theme.textStyles.rm16};
  }
  @media (min-width: 769px) {
    ${theme.textStyles.rb24};
    font-family: 'Open Sans'
  }
  color: ${theme.colors.defaultTextColor};
`


export const Title2 = styled.div`
  user-select: none;
  @media (max-width: 768px) {
    ${theme.textStyles.rm20};
  }
  @media (min-width: 769px) {
    ${theme.textStyles.rb24};
    font-family: 'Open Sans'
  }
  color: ${theme.colors.defaultTextColor};
`

export const Headline = styled.div`
  user-select: none;
  ${theme.textStyles.rm18};
  color: ${theme.colors.defaultTextColor};
  @media (min-width: 769px) {
    font-family: 'Open Sans'
  }
`

export const Description = styled.div`
  user-select: none;
  ${theme.textStyles.rr16};
  color: ${theme.colors.defaultTextColor};
  @media (min-width: 769px) {
    font-family: 'Open Sans'
  }
`

export const Subhead = styled.div`
  user-select: none;
  ${theme.textStyles.rb14};
  color: ${theme.colors.defaultTextColor};
  @media (min-width: 769px) {
    font-family: 'Open Sans'
  }
`

export const SubheadEmphasized = styled.div`
  user-select: none;
  ${theme.textStyles.rb14};
  color: ${theme.colors.defaultTextColor};
  @media (min-width: 769px) {
    font-family: 'Open Sans'
  }
`

export const Body = styled.div`
  user-select: none;
  @media (max-width: 768px) {
    ${theme.textStyles.rr14};
  }
  @media (min-width: 769px) {
    ${theme.textStyles.rr16};
    font-family: 'Open Sans'
  }
  color: ${theme.colors.defaultTextColor};
`

export const Body1 = styled.div`
  user-select: none;
  ${theme.textStyles.rr14};
  color: ${theme.colors.defaultTextColor};
  @media (min-width: 769px) {
    font-family: 'Open Sans'
  }
`

export const Caption2 = styled.div`
  user-select: none;
  ${theme.textStyles.rm12};
  color: ${theme.colors.defaultTextColor};
  @media (min-width: 769px) {
    font-family: 'Open Sans'
  }
`

export const Caption = styled.div`
  user-select: none;
  @media (max-width: 768px) {
    ${theme.textStyles.rm14};
  }
  @media (min-width: 768px) {
    ${theme.textStyles.rm20};
    font-family: 'Open Sans'
  }
  color: ${theme.colors.defaultTextColor};
`

export const Caption1 = styled.div`
  user-select: none;
  @media (max-width: 768px) {
    ${theme.textStyles.rb10};
  }
  @media (min-width: 768px) {
    ${theme.textStyles.rb11};
    font-family: 'Open Sans'
  }
  color: ${theme.colors.defaultTextColor};
`
